module.exports = __webpack_public_path__ + "static/img/mobile_home_tzjsmfw_swkc.ca69175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_tzjsmfw_swkc.png
// module id = TOQc
// module chunks = 21